import { useState } from "react";
import validateInfo from "./validateInfo";
import { useBetween } from "use-between";
import { useSelector } from "react-redux";

const useForm = () => {
  const { setShowPaymentModal, setShowServiceRequestModal } = useBetween(
    useSelector((state) => state.useSharedState)
  );
  const handleClosePaymentModal = () => {
    setShowServiceRequestModal(true);
    setShowPaymentModal(false);
  };
  const [values, setValues] = useState({
    cardName: "",
    cardNumber: "",
    cardType: "",
    cardExpiration: "",
    cardSecurityCode: "",
    cardPostalCode: "",
    focus: "",
  });

  const [errors, setErrors] = useState({ show: false });

  const handleFocus = (e) => {
    setValues({
      ...values,
      focus: e.target.name === "cardSecurityCode" ? "cvc" : e.target.name,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors(validateInfo(values));
  };

  return {
    handleChange,
    handleFocus,
    handleSubmit,
    handleClosePaymentModal,
    values,
    errors,
  };
};

export default useForm;
